// Ordered journey. "min" = hidden Crew Score threshold to reach that destination.
export const DESTINATIONS = [
  { name: "East Blue", min: 0 },
  { name: "Reverse Mountain", min: 41 },
  { name: "Whisky Peak", min: 44 },
  { name: "Little Garden", min: 46.5 },
  { name: "Drum", min: 49 },
  { name: "Alabasta", min: 52 },
  { name: "Jaya", min: 54.5 },
  { name: "Skypiea", min: 57 },
  { name: "Long Ring Long Land", min: 59.5 },
  { name: "Water 7", min: 62 },
  { name: "Enies Lobby", min: 64.5 },
  { name: "Thriller Bark", min: 66.5 },
  { name: "Sabaody", min: 68.5 },
  { name: "Isola degli Uomini-Pesce", min: 70.5 },
  { name: "Punk Hazard", min: 73 },
  { name: "Dressrosa", min: 76 },
  { name: "Zou", min: 78.5 },
  { name: "Whole Cake Island", min: 81 },
  { name: "Wano", min: 83.5 },
  { name: "Egghead", min: 86 },
  { name: "Elbaph", min: 88.5 },
  { name: "Lodestar", min: 91.5 },
  { name: "Laugh Tale", min: 94.5 },
];
